import { render } from "./technical-table.vue?vue&type=template&id=0825751e"
import script from "./technical-table.vue?vue&type=script&lang=js"
export * from "./technical-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__